import React from "react";
import { useLocation } from "react-router-dom";
import logo from "../assets/optimized/echo-logo-wide-96.webp";
import { Icon } from "./Icon";
import { WHATSAPP_START_URL } from "../siteConfig";

export const Navigation = () => {
  const location = useLocation();
  const isHomeRoute = location.pathname === "/";

  const brandHref = isHomeRoute ? "#page-top" : "/";
  const helpHref = isHomeRoute ? "#contact" : "/#contact";
  const brandClassName = [
    "navbar-brand",
    "brand-link",
    "app-brand",
    isHomeRoute ? "page-scroll" : "",
  ]
    .filter(Boolean)
    .join(" ");
  const helpClassName = ["nav-meta-link", isHomeRoute ? "page-scroll" : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top app-nav app-nav-simple">
      <div className="container app-nav-shell">
        <a
          className={brandClassName}
          href={brandHref}
          data-analytics-label="nav_home"
        >
          <img
            src={logo}
            alt="Echo MSG logo"
            className="brand-logo"
            decoding="async"
            fetchPriority="high"
            height="81"
            width="96"
          />
          <span className="app-brand-copy">
            <span className="brand-wordmark">Echo MSG</span>
            <span className="brand-submark">for WhatsApp</span>
          </span>
        </a>

        <div className="app-nav-actions">
          <a href="/blog" className="nav-meta-link nav-blog-link" aria-current={location.pathname.startsWith("/blog") ? "page" : undefined} data-analytics-label="nav_blog">Blog</a>
          <a
            href={helpHref}
            className={helpClassName}
            data-analytics-label="nav_help_center"
          >
            <Icon name="help" />
            <span>Help Center</span>
          </a>

          <a
            href={WHATSAPP_START_URL}
            className="btn btn-custom nav-cta-button"
            data-analytics-label="nav_try_on_whatsapp"
            aria-label="Try Echo MSG on WhatsApp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="cta-whatsapp-icon" aria-hidden="true">
              <Icon name="whatsapp" />
            </span>
            <span className="nav-cta-label-full">Chat on WhatsApp</span>
            <span className="nav-cta-label-compact">Try it</span>
          </a>

          <span className="nav-icon-button" aria-hidden="true">
            <Icon name="globe" />
          </span>
        </div>
      </div>
    </nav>
  );
};
